module.exports = __webpack_public_path__ + "img/i_homework-status-partly-checked.0288c044.svg";